import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { messages } from './messages';
import DarkNoDataFoundIcon from './assets/img/icon-dark.png';
import { selectThemeKey } from 'styles/theme/slice/selectors';
import { useSelector } from 'react-redux';
import { NoDataFoundLabel, NoDataFoundSubLabel } from '../labels';
import { NoDataFoundIcon } from 'app/assets/icons';

const IconDark = () => <img src={DarkNoDataFoundIcon} alt="" />;

type Props = {
  noDataLabel?: string;
  noDataSubLabel1?: string;
  noDataSubLabel2?: string;
  isBooking?: boolean;
};

const NoDataFound = ({
  noDataLabel,
  isBooking,
  noDataSubLabel1,
  noDataSubLabel2,
}: Props) => {
  const { t } = useTranslation();
  const ThemeKey = useSelector(selectThemeKey);
  return (
    <DivWrapper className="no-data-wrapper">
      <IconWrapper className="no-data-icon-wrapper">
        {ThemeKey === 'light' ? <NoDataFoundIcon /> : <IconDark />}
      </IconWrapper>
      <TextWrapper>
        <NoDataFoundLabel className="nodata-found-label">
          {noDataLabel ? noDataLabel : 'No data found'}
        </NoDataFoundLabel>
        <NoDataFoundSubLabel>{noDataSubLabel1}</NoDataFoundSubLabel>
        <NoDataFoundSubLabel>{noDataSubLabel2}</NoDataFoundSubLabel>
      </TextWrapper>
    </DivWrapper>
  );
};

export default NoDataFound;
const DivWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const IconWrapper = styled.div`
  padding: 20px 0 6px 0;
`;
const TextWrapper = styled.div`
  width: 100%;
  text-align: center;
  padding: 20px 0 6px 0;
`;
